import * as React from "react";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { useAuthStore } from "../hooks/useAuthStore";
import AuthStore from "../store/AuthStore";
import Tabs from 'devextreme-react/tabs';
import { routesTabs } from "../router/routerTabs";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import DropDownButton from 'devextreme-react/drop-down-button';
import { CheckBox } from 'devextreme-react/check-box';
import { Template } from 'devextreme-react/core/template';
import { useRef, useState } from "react";
import DropDownGridReportViewList from "./DropDownGridReportViewList";
import MainTabs from "./MainTabs";
import { isMobileDevice } from "../utils/DeviceDetect";


const reloadDataSourceBaseAndReports = () => {
    if (dataSourceBase) {
        dataSourceBase.reload();
    }
    if (dataSourceReports) {
        dataSourceReports.reload();
    }
}
const reloadDataSourceBase = () => {
    if (dataSourceBase) {
        dataSourceBase.reload();
    }
}


const defaultTabs = (authStore, mode: "all" | "notAdmin" | "admin") => routesTabs
    .filter(route => true
        && ((authStore.isAuth
            && route.canWhenAuth
            && (!route.needAdmin && (mode == "all" || mode == "notAdmin")
                || route.needAdmin && authStore.user?.IsAdmin && (mode == "all" || mode == "admin")
            )
        )
//        || (!authStore.isAuth && !route.needAuth)
    )
    )
    .map(route => {
        return {
            id: route.id,
            title: route.title,
            text: route.title,
            key: route.path,
            //                    component: route.component,
            componentJSX: route.componentJSX,
            fixedTab: true,
            needAdmin: route.needAdmin,
        }
    }
    );
const tabsList = [];

const tabsListStore = new ArrayStore({
    key: 'id',
    data: tabsList,
    onInserted: (changes) => {
        console.log(changes);
    },
    onRemoved: (key) => {
        console.log(key);
    }

});
const dataSourceBase = new DataSource({
    store: tabsListStore,
    reshapeOnPush: true,
    sort: (e) => {
        let ind;
        if (e.fixedTab) {
            ind = Number.MIN_SAFE_INTEGER + e.id
        }
        else {
            ind = - e.id;
        }
        return ind;
    },
});
const getDataSourceReports = () => {
    return new DataSource({
        store: tabsListStore,
        reshapeOnPush: true,
        //            filter: ['id', '>', 10],
        filter: ['fixedTab', '=', false],
        sort: (a) => {
            return -a.id;
        },
    });
};
const dataSourceReports = getDataSourceReports();

export const MainIsAuthToolbar = () => {
    const authStore: AuthStore = useAuthStore();
    let refMain = useRef(null);
    let refReports = useRef(null);
    const tabsInstance = (aref) => {
        let tabs = aref.current;
        if (tabs) {
            let instance = tabs.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }
    const getShowSetupLS = () => {
        return localStorage.getItem("showSetupAtMainIsAuthToolbar") == "true";
    }
    const setShowSetupLS = (value) => {
        localStorage.setItem("showSetupAtMainIsAuthToolbar", value);
        setShowSetup(value);
    }

    const [showSetup, setShowSetup] = useState(getShowSetupLS() && authStore.user?.IsAdmin);

    const afterInsert = (item) => {
        reloadDataSourceBaseAndReports();
        setTabReportsSelectedItem(item);
    }
    authStore.storage["afterInsertToBuildedReports"] = afterInsert;
    authStore.storage["onAfterLogout"] = () => {
        tabsList.length = 0;
    }

    const addDefTabs2TabsList = (needReload) => {
        const tabs = defaultTabs(authStore, "all");
        for (let i = 0; i < tabs.length; i++) {
            let item = tabs[i];
            let ind = tabsList.indexOf(item);
            if (ind > -1) { continue; }
            tabsListStore.insert(item);
        }
        if (needReload) {
            reloadDataSourceBase();
        }
    }

    addDefTabs2TabsList(true);

    const closeButtonHandler = (item) => {
        if (item.fixedTab) {
            return;
        }
        let newItem = tabsList.filter(it => it.fixedTab == false && it.id > item.id).sort((a, b) => b - a)[0];
        if (!newItem) {
            newItem = tabsList.filter(it => it.fixedTab == false && it.id < item.id).sort((a, b) => a - b)[0];
        }
        dataSourceBase.store().remove(item.id);
        reloadDataSourceBaseAndReports();
        setTimeout(() => {
            if (newItem) {
                setTabReportsSelectedItem(newItem);
            }
            else {
                newItem = tabsInstance(refMain).option("selectedItem");
                setTabMainSelectedItem(newItem);
            }
        }, 300);

    };
    const onTabsInitialized = (args) => {
        let comp = args.component;
        comp.option("selectedIndex", 0);
    }
    const setTabReportsSelectedItem = (item) => {
        const instance = tabsInstance(refReports);
        if (instance) {
            //            instance.option("selectedItem", item);
            instance.option("value", [item.id]);
        }
    }
    const setTabMainSelectedItem = (item) => {
        const instance = tabsInstance(refMain);
        if (instance) {
            instance.option("selectedItem", item);
        }
    }
    const setTabMainSelectedIndex = (newIndex) => {
        const instance = tabsInstance(refMain);
        if (instance) {
            instance.option("selectedIndex", newIndex);
        }
    }

    const renderTitle = React.useCallback((data) => (
        <React.Fragment>
            {false &&
                <table>
                    <tr>
                        <td width="90%" align="left">
                            {data.title}
                        </td>
                        {!data.fixedTab &&
                            <td align="right" width="10%" >
                                <i
                                    className="dx-icon dx-icon-close"
                                    onClick={async (e) => { closeButtonHandler(data); e.preventDefault(); }}
                                />
                            </td>
                        }
                    </tr>
                </table>
            }
            {true &&
                <div
                //                                style={{ maxWidth: "120px", overflow: "hidden" }}
                >
                    <span style={{ alignContent: "start" }}>
                        {data.title}
                    </span>
                    {!data.fixedTab &&
                        <span style={{ alignContent: "end" }}>
                            <i
                                className="dx-icon dx-icon-close"
                                onClick={async (e) => { closeButtonHandler(data); e.preventDefault(); }}
                            />
                        </span>
                    }
                </div>
            }
        </React.Fragment>
    ), [closeButtonHandler]);


    const MainButtons = () => {
        return (
            <Tabs
                ref={refMain}
//                dataSource={dataSourceMain}
                width="250px"
                scrollByContent={false}
                showNavButtons={false}
//                itemRender={renderTitle}
                repaintChangesOnly={true}
                onInitialized={onTabsInitialized}
                onSelectedItemChange={
                    (e) => {
                        if (e && authStore.storage["setMainTabsSelectedItem"]) {
//                            authStore.storage["setMainTabsSelectedItem"](e);
                            authStore.storage["setMainTabsSelectedItem"](e.options.data);
                        }
                    }
                }
                onItemClick={
                    (e) => {
                        if (e && authStore.storage["setMainTabsSelectedItem"]) {
//                            authStore.storage["setMainTabsSelectedItem"](e.itemData);
                            authStore.storage["setMainTabsSelectedItem"](e.itemData.options.data);
                        }
                    }
                }
            >
                <Item
                    text="Список отчетов"
                    visible={true}
                    options={{
                        data: tabsList[0]
                    }}
                />
                <Item
                    text="Настройки"
                    visible={showSetup}
                    options={{ data: tabsList[1] }}
                />
            </Tabs>
        )
    }
    const BuildedReports = () => {
        return (
            <div style={{ width: "40vw" }}>
                <DropDownGridReportViewList
                    innerRef={refReports}
                    //                    ref={refReports}
                    dataSource={dataSourceReports}
                    afterDelete={closeButtonHandler}
                    onSelectedItemChange={
                        (e) => {
                            if (e && authStore.storage["setMainTabsSelectedItem"]) {
                                authStore.storage["setMainTabsSelectedItem"](e);
                            }
                        }
                    }
                    fieldIdName="id"
                    fieldTitleName="title"
                    placeholder="Построенные отчеты"
                    deleting={true}
                />
            </div>
        )
    }
    const RightButton = () => {
        return (
            <DropDownButton
                className="drop-down-button-logoff"
                splitButton={true}
                useSelectMode={false}
                text={authStore.user?.UserName}
                icon="images/gkLogoIcon.png"
                items={[
                    {
                        id: 1,
                        name: "Показывать настройки",
                        visible: authStore.user?.IsAdmin,
                        template: "checkBoxSetup",
                    },
                    {
                        id: 2,
                        name: 'Выйти',
                        icon: 'runner',
                        onClick: (e) => { authStore.logout(); }
                    },
                ]}

                displayExpr="name"
                keyExpr="id"
                //                                        onButtonClick={onButtonClick}
                onItemClick={
                    (e) => {
                        if (e.itemData.onClick) {
                            e.itemData.onClick(e);
                        }
                    }
                }
            >
                <Template name="checkBoxSetup" render={
                    () => <CheckBox
                        defaultValue={showSetup}
                        text="Показывать настройки"
                        onValueChange={
                            (args) => {
                                let localShowSetup = args == true;
                                setShowSetupLS(localShowSetup);
                                if (!localShowSetup) {
                                    const visible = tabsInstance(refMain).option("selectedItem").visible;
                                    if (!visible) {
                                        setTabMainSelectedIndex(0);
                                    }
                                }
                            }
                        }
                    />
                }
                />
            </DropDownButton>
        )
    }

    return (
        <Toolbar
            visible={!isMobileDevice}
        >
            <Item location="before"
                render={MainButtons}
            />
            <Item location="center"
                render={BuildedReports} />
            <Item location="after"
                render={RightButton}
            />
        </Toolbar>
    )
}
export const MainIsAuthCenter = () => {
    return (
        <MainTabs
            dataSource={dataSourceBase}
        />
    )
}


